// extracted by mini-css-extract-plugin
export default {"EledoLogin":"EledoPageHeader_EledoLogin__Vx8tt"};